module.exports = __webpack_public_path__ + "static/aws-5d7dd7770d9e540ff22e6f1aef40f84c.png";